// extracted by mini-css-extract-plugin
export default {"ArticlePage":"ArticlePage__ArticlePage___DMABS"};